<div class="scenario-list">
  <div class="header">
    <button class="back-button" (click)="back()">
      <img src="assets/icons/arrow-back.svg" width="24" height="24" [alt]="'common.back' | translate" />
    </button>
    <h2>{{ 'scenario.title' | translate }}</h2>
  </div>

  <div class="empty-state" *ngIf="!scenarios?.length">{{ 'scenario.empty' | translate }}</div>
  
  <div class="scenario-card" *ngFor="let scenario of scenarios; let i = index; trackBy: trackByScenario" (click)="toggleExpand(scenario)">
    <div class="scenario-header">
      <span class="scenario-id">#{{ scenario.id }} </span>      
      <span class="scenario-name-display">{{ scenario.name }}</span>
      <span class="scenario-hint">{{ 'common.click_to_expand' | translate }}</span>
    </div>

    <div class="scenario-details" *ngIf="isExpanded(scenario)" (click)="$event.stopPropagation()">
      <div class="header-grid">
        <div class="form-group">
          <label for="name">{{ 'scenario.name' | translate }}</label>
          <input id="name" type="text" [(ngModel)]="scenario.name" [placeholder]="'scenario.name_placeholder' | translate" />
        </div>
        <div>
          <button class="remove-button" (click)="deleteScenario(scenario); $event.stopPropagation()" [title]="'scenario.delete' | translate">
            <img src="assets/icons/close.svg" width="20" height="20" [alt]="'common.remove' | translate" />
          </button>
        </div>
      </div>     
      
      <div class="conditions-container">
        <h5>{{ 'scenario.conditions' | translate }}</h5>
        <div *ngFor="let condition of scenario.conditions; let j = index"           
              class="condition-card"
              [class.deleting]="isDeletingCondition(i, j)"
              [class.adding]="isAddingCondition(i, j)">
          <div class="condition-header">            
            <div></div>
            <button class="remove-button" (click)="removeCondition(i, j)" [title]="'scenario.remove_condition' | translate">
              <img src="assets/icons/close.svg" width="20" height="20" [alt]="'common.remove' | translate" />
            </button>
          </div>
          <div class="condition-grid">
            <div class="form-group">
              <label>{{ 'common.type' | translate }}</label>
              <select [(ngModel)]="condition.ioType">
                <option value="RCIOOutput">{{ 'common.output' | translate }}</option>
                <option value="RCIOInput">{{ 'common.input' | translate }}</option>                
              </select>
            </div>
            
            <div class="form-group" *ngIf="condition.ioType === 'RCIOOutput'">
              <label>{{ 'common.output' | translate }}</label>
              <select [(ngModel)]="condition.outputEid">
                <option *ngFor="let output of outputs" [ngValue]="output.eid">
                  {{ output.name }}
                </option>
              </select>
            </div>
            <div class="form-group" *ngIf="condition.ioType === 'RCIOInput'">
              <label>{{ 'common.input' | translate }}</label>
              <select [(ngModel)]="condition.inputEid">
                <option *ngFor="let input of inputs" [ngValue]="input.eid">
                  {{ input.name }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label>{{ 'common.state' | translate }}</label>
              <select [(ngModel)]="condition.state">
                <option value="on">{{ 'common.on' | translate }}</option>
                <option value="off">{{ 'common.off' | translate }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <button class="add-button" (click)="addCondition(i)">
        <img src="assets/icons/plus.svg" width="20" height="20" [alt]="'common.add' | translate" />
        {{ 'scenario.add_condition' | translate }}
      </button>

      <div class="actions-container">
        <h5>{{ 'scenario.actions' | translate }}</h5>
        <div *ngFor="let action of getSortedActions(scenario); let j = index"           
              class="action-card"
              [class.deleting]="isDeletingAction(i, j)"
              [class.adding]="isAddingAction(i, j)"
              [class.swapping]="isSwappingAction(i, j)"
              [class.swap-up]="getSwapDirection(i, j) === 'up'"
              [class.swap-down]="getSwapDirection(i, j) === 'down'">
          <div class="action-header">
            <div class="action-controls-left">
              <button class="order-button" 
                      (click)="moveActionUp(i, j)" 
                      [disabled]="!canMoveUp(i, j)"
                      [title]="'common.move_up' | translate">
                <img src="assets/icons/arrow-up.svg" width="16" height="16" [alt]="'common.move_up' | translate" />
              </button>
              <button class="order-button" 
                      (click)="moveActionDown(i, j)" 
                      [disabled]="!canMoveDown(i, j)"
                      [title]="'common.move_down' | translate">
                <img src="assets/icons/arrow-down.svg" width="16" height="16" [alt]="'common.move_down' | translate" />
              </button>
            </div>
            <button class="remove-button" (click)="removeAction(i, j)" [title]="'common.remove_action' | translate">
              <img src="assets/icons/close.svg" width="20" height="20" [alt]="'common.remove' | translate" />
            </button>
          </div>
          <div class="action-grid">
            <div class="form-group">
              <label>{{ 'common.type' | translate }}</label>
              <select [(ngModel)]="action.type">
                <option value="output">{{ 'common.output' | translate }}</option>
                <option value="wait">{{ 'scenario.action.wait' | translate }}</option>    
                <option value="allOff">{{ 'common.all_off' | translate }}</option>            
              </select>
            </div>

            <div class="form-group" *ngIf="action.type === 'output'">
              <label>{{ 'common.output' | translate }}</label>
              <select [(ngModel)]="action.outputEid">
                <option *ngFor="let output of outputs" [ngValue]="output.eid">
                  {{ output.name }}
                </option>
              </select>
            </div>
            <div class="form-group" *ngIf="action.type === 'output'">
              <label>{{ 'common.action' | translate }}</label>
              <select [(ngModel)]="action.action">
                <option value="on">{{ 'common.on' | translate }}</option>
                <option value="off">{{ 'common.off' | translate }}</option>
                <option value="toggle">{{ 'common.toggle' | translate }}</option>                
              </select>
            </div>

            <div class="form-group" *ngIf="action.type === 'wait'">
              <label>{{ 'scenario.wait_seconds' | translate }}</label>
              <input type="number" min="1" [(ngModel)]="action.wait"/>              
            </div>
          </div>
        </div>
      </div>

      <button class="add-button" (click)="addAction(i)">
        <img src="assets/icons/plus.svg" width="20" height="20" [alt]="'common.add' | translate" />
        {{ 'common.add_action' | translate }}
      </button>
    </div> 
  </div>

  <div class="add-scenario">
    <button class="add-button" (click)="addScenario()">
      <img src="assets/icons/plus.svg" width="20" height="20" [alt]="'common.add' | translate" />
      {{ 'scenario.add' | translate }}
    </button>
  </div>

  <div class="actions">
      <button class="cancel-button" (click)="back()">{{ 'common.back' | translate }}</button>
      <button class="save-button" (click)="save()">{{ 'common.save' | translate }}</button>
  </div>

</div>
